import * as types from 'reducer/actionTypes'

const initialState = {
	status: false,
	message: null,
	isError: false,
	resultCode : null
};

export default function popup(state = initialState, action){
	switch(action.type){

		case types.FETCH_MESSAGEBOX_ON :
			return{
				...state,
				status: true,
				message: action.message,
				isError: action.isError,
				resultCode : action.resultCode
			}
		case types.FETCH_MESSAGEBOX_OFF :
			return{
				...state,
				status: false,
				message: null,
				isError: false,
				resultCode: null
			}

		default:
			return state
	}
}